import https from "../repositories/https";

export default {
  currentMetrices(config) {
    return https.get(`metrics.json`, config);
  },

  ticketByTypes(config) {
    return https.get(`types.json`, config);
  },

  ticketByGroups(config) {
    return https.get(`tickets_by_groups.json`, config);
  },

  ticketPriority(config) {
    return https.get(`priorities.json`, config);
  },

  ticketByChannel(payload, config) {
    return https.post(`channels.json`, payload, config);
  },

  ticketSummary(config) {
    return https.get(`summary.json`, config);
  },
};
